import { render, staticRenderFns } from "./ShowPhotos.vue?vue&type=template&id=263f55b9&"
import script from "./ShowPhotos.vue?vue&type=script&lang=js&"
export * from "./ShowPhotos.vue?vue&type=script&lang=js&"
import style0 from "./ShowPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports